function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "49D9358E-D812-453B-BE3F-0D7B82549CDE");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M10.2857148,20.2105263 C4.60507138,20.2105263 0,15.6862459 0,10.1052632 C0,4.52428042 4.60507138,0 10.2857148,0 C15.9663582,0 20.5714296,4.52428042 20.5714296,10.1052632 C20.5714296,15.6862459 15.9663582,20.2105263 10.2857148,20.2105263 Z M10.2857149,19.5136117 C15.5745898,19.5136117 19.86207,15.3013506 19.86207,10.1052632 C19.86207,4.90917582 15.5745898,0.696914723 10.2857149,0.696914723 C4.99683992,0.696914723 0.709359664,4.90917582 0.709359664,10.1052632 C0.709359664,15.3013506 4.99683992,19.5136117 10.2857149,19.5136117 Z M2.48275867,10.4424607 C2.28687441,10.4424607 2.12807884,10.253949 2.12807884,10.0214081 C2.12807884,9.78886713 2.28687441,9.60035545 2.48275867,9.60035545 L4.43349776,9.60035545 C4.62938202,9.60035545 4.78817759,9.78886713 4.78817759,10.0214081 C4.78817759,10.253949 4.62938202,10.4424607 4.43349776,10.4424607 L2.48275867,10.4424607 Z M9.93103459,2.43920138 C9.93103459,2.24675369 10.1229126,2.09074402 10.359606,2.09074402 C10.5962995,2.09074402 10.7881775,2.24675369 10.7881775,2.43920138 L10.7881775,4.31629139 C10.7881775,4.50873907 10.5962995,4.66474874 10.359606,4.66474874 C10.1229126,4.66474874 9.93103459,4.50873907 9.93103459,4.31629139 L9.93103459,2.43920138 Z M16.1379323,10.4424607 C15.942048,10.4424607 15.7832524,10.253949 15.7832524,10.0214081 C15.7832524,9.78886713 15.942048,9.60035545 16.1379323,9.60035545 L18.0886713,9.60035545 C18.2845556,9.60035545 18.4433512,9.78886713 18.4433512,10.0214081 C18.4433512,10.253949 18.2845556,10.4424607 18.0886713,10.4424607 L16.1379323,10.4424607 Z M14.7605132,6.44293084 C14.6205816,6.57760185 14.3960227,6.57532742 14.2589468,6.43785077 C14.121871,6.30037412 14.124186,6.07975485 14.2641176,5.94508384 L15.5646103,4.69348193 C15.7045419,4.55881092 15.9291008,4.56108535 16.0661767,4.698562 C16.2032525,4.83603865 16.2009375,5.05665792 16.0610059,5.19132893 L14.7605132,6.44293084 Z M4.25615786,4.86372571 C4.25598134,4.62162029 4.38650658,4.39758159 4.59908506,4.27512373 C4.81167284,4.15266051 5.07442082,4.15016385 5.30511089,4.27776156 L11.6667339,8.21884866 C12.4807504,8.73062398 12.9008972,9.67374323 12.7313069,10.6085181 C12.5617157,11.5432979 11.8357692,12.2856979 10.891903,12.4895983 C9.94803064,12.6935001 8.97208126,12.3187474 8.40983067,11.5264005 L4.37754974,5.23789987 C4.30189748,5.13031259 4.25970214,5.00307054 4.25615786,4.86372571 Z M5.01164644,4.91931448 L9.00079977,11.1412723 C9.38966477,11.688811 10.0758943,11.9523148 10.7395653,11.808944 C11.4032424,11.665572 11.9137012,11.1435437 12.032954,10.4862269 C12.1522078,9.82890511 11.8567682,9.16572082 11.286377,8.80710449 L5.01164644,4.91931448 Z",
  id: "path-5"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Dashboard",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Users",
  transform: "translate(-126.000000, -123.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Menu",
  transform: "translate(0.000000, 92.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-not-selected",
  transform: "translate(120.000000, 23.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  transform: "translate(0.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Icons/Dashboard"
}, /*#__PURE__*/React.createElement("g", {
  id: "Color/Primary/Brand",
  transform: "translate(6.000000, 5.894737)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-5",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-5"
})), /*#__PURE__*/React.createElement("use", {
  id: "Mask",
  fill: "#EAECF0",
  fillRule: "nonzero",
  xlinkHref: "#path-5"
}), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask-5)",
  id: "Rectangle-Copy-3"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3.673469, -3.609022)"
}, /*#__PURE__*/React.createElement("rect", {
  x: 0,
  y: 0,
  width: 27.9183693,
  height: 27.4285736
}))))))))));

var SvgDashboard = function SvgDashboard(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "22px",
    viewBox: "0 0 21 22",
    fill: "#9FA5B7",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDashboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Dashboard.58a4d2c8.svg";
export { ForwardRef as ReactComponent };